import { get, groupBy, map } from 'lodash'

import { COMPONENT_INGREDIENT_TYPES } from '../../../../common/constants'

const ingredientComponentDetailsFormInitialValues = ({
  isWholeFood,
  isVague,
  componentIngredients,
}) => {
  const componentIngredientsGroupedByType = groupBy(
    componentIngredients,
    'type',
  )

  return {
    isWholeFood,
    isVague,
    definiteIngredientIds: map(
      get(
        componentIngredientsGroupedByType,
        COMPONENT_INGREDIENT_TYPES.DEFINITE,
      ),
      'id',
    ),

    probableIngredientIds: map(
      get(
        componentIngredientsGroupedByType,
        COMPONENT_INGREDIENT_TYPES.PROBABLE,
      ),
      'id',
    ),
  }
}

export default ingredientComponentDetailsFormInitialValues
